/*
 * @Author: shiguang
 * @Date: 2023-05-23 18:11:39
 * @LastEditors: liuliangliang liuliangliang@sniffgroup.com
 * @LastEditTime: 2024-07-03 14:30:22
 * @Description: MenuList
 */
import { useEffect, useLayoutEffect, useMemo, useState } from 'react';
import { Badge, Menu, Tooltip } from 'antd';
import { useAtom } from 'jotai';
import { cloneDeep, debounce } from 'lodash';
import { useDebounceFn } from 'ahooks';
import { jumpPage } from '@/utils';
import { Site, getCountryByNavigatorLang } from '@/const';
import { CustomerDetail } from '@/model';
import { ROUTER_BASENAME } from '@/config/base';
import { getToken, request, getShopId } from '@/config/request/interceptors';
import './index.scss';
import {
    data,
    JP_CROSS_MALL_WHITE,
    JP_GOODS_PURCHASE,
    JP_GOODS_PURCHASE_HAS_TIKTOK,
    STOCK_JP_SHIPPING
} from './data';
// eslint-disable-next-line no-duplicate-imports
import styles from './index.scss';
const getMenuTitle = (icon: string, label: string) => {
    return (
        <div className="flex items-center menu-item-warp">
            <img src={icon} alt="" width={20} height={20} />
            <span
                style={{
                    marginLeft: 8
                }}
            >
                {label}
            </span>
        </div>
    );
};
const useList = () => {
    // 规避掉hook只能在react.Fc 中调用;

    const [useInfo] = useAtom(CustomerDetail);
    const { stationCode, systemSource } = useInfo || {};
    const isD2C = systemSource === 1;
    const [msg, setMsg] = useState<string>();
    const [abnormalOrderCount, setAbnormalOrderCount] = useState<number>(0);
    const getPrivateUnreadCount = async () => {
        const res = await request.customer.notify.getPrivateUnreadCount();
        let msg;
        if ((res.data || 0) <= 0) {
            msg = null;
        } else if ((res.data || 0) < 99) {
            msg = res.data;
        } else {
            msg = '99+';
        }
        setMsg(msg);
    };
    const getCountAbnormalOrderCount = async () => {
        const res = await request.order.abnormalOrder.countAbnormalOrderCount();
        setAbnormalOrderCount(res.data?.totalOrderCount || 0);
    };
    useEffect(() => {
        if (getToken()) {
            getPrivateUnreadCount();
            getCountAbnormalOrderCount();
        }
    }, []);
    const [isJpPurchase, setIsJpPurchase] = useState(false);
    const [isTikTokShop, setIsTikTokShop] = useState(false);
    const [isCrossMall, setIsCrossMall] = useState(false);
    const [overseasInv, setOverseasInv] = useState<any>({});
    useEffect(() => {
        if (!useInfo?.superCustomerId) return;
        console.log('useInfo', useInfo, getShopId());
        const shopInfo =
            useInfo.customerShopList?.find(
                (v) => v.customerShopId === getShopId()
            ) ?? {};
        request.customer.shop
            .supportJpPurchase({
                superCustomerId: useInfo.superCustomerId
            })
            .then((res) => {
                setIsJpPurchase(!!res.data);
            });
        if (getShopId()) {
            setIsTikTokShop(shopInfo?.customerShopPlatform === 11);
        }
        request.wms.wms.baseConfigGrayOverseasInv().then((res) => {
            setOverseasInv(res.data ?? {});
        });
        request.wms.wms
            .baseConfigGetAutoTransferOverseasCustomerIds()
            .then((res) => {
                const whiteList = res.data;
                const id = shopInfo?.customerId ?? 0;
                setIsCrossMall(
                    !!whiteList?.includes(id) &&
                        shopInfo?.customerShopPlatform !== 4
                );
            });
    }, [useInfo]);
    const setRouter = (routes: any, plat: string, site?: string) => {
        const newRoute = cloneDeep(routes);
        const setRt = (routes: any) => {
            return routes.filter((t: any) => {
                if (t.children) {
                    t.children = setRt(t.children);
                }
                if (t.icon) {
                    t.icon = (
                        <i
                            className={
                                'user-icon icon-' +
                                t.icon +
                                (isD2C ? ' d2c' : ' b2b')
                            }
                        />
                    );
                }
                if (t.menulink === '/order/AbnormalOrder') {
                    t.label = (
                        <div className="absolute contents">
                            {window._$m.t('异常订单')}
                            <Badge
                                className="absolute"
                                count={abnormalOrderCount}
                            />
                        </div>
                    );
                }
                if (t.menulink === '/fund/BillList?type=1') {
                    t.label = (
                        <div
                            className={styles.msg}
                            style={{ marginLeft: '14px' }}
                        >
                            <Tooltip
                                title={
                                    <span className="CustomTooltipTitle">
                                        {window._$m.t(
                                            '借记授权是当系统账户自动扣除以外的费用发生时，向用户收取额外费用的文件。\n 当用户批准付款请求时，费用将从系统余额中扣除。\n ※注意: 如在发出日期起7天内未能确认付款，将自动扣除有关费用。'
                                        )}
                                    </span>
                                }
                            >
                                <span
                                    className="submenu"
                                    style={{ marginLeft: '2px' }}
                                >
                                    <i className="iconfont icon-wenhao1 text-[12px] pr-[2px] " />
                                </span>
                            </Tooltip>
                            {window._$m.t('我的账单')}
                        </div>
                    );
                }

                return !(
                    (t?.plat && t.plat !== plat) ||
                    (t?.site && !t.site.includes(site))
                );
            });
        };
        return setRt(newRoute);
    };
    const filterTouter = (
        routes: any,
        showAuth: number[],
        hiddenAuth: number[]
    ) => {
        const newRoute = cloneDeep(routes);
        const setRt = (routes: any) => {
            return routes.filter((t: any) => {
                if (t.children) {
                    t.children = setRt(t.children);
                }
                // 是否隐藏判断
                if (
                    t?.hiddenAuth &&
                    hiddenAuth.some((a) => t?.hiddenAuth.includes(a))
                ) {
                    return false;
                }
                // 是否显示判断
                if (
                    t?.showAuth &&
                    !showAuth.some((a) => t?.showAuth.includes(a))
                ) {
                    return false;
                }
                return true;
            });
        };
        return setRt(newRoute);
    };
    const list = useMemo(() => {
        const menuList = setRouter(
            data,
            isD2C ? 'd2c' : 'b2b',
            useInfo?.site ?? 'ja'
        );
        console.log('menuList', menuList, isD2C, stationCode);
        let newList = [];
        const showAuth: number[] = [];
        const hiddenAuth: number[] = [];
        if (isJpPurchase && !isTikTokShop) {
            showAuth.push(JP_GOODS_PURCHASE);
        }
        if (isJpPurchase) {
            showAuth.push(JP_GOODS_PURCHASE_HAS_TIKTOK);
        }
        const isShowStockJpBtn = () => {
            if (!isD2C) return false;

            // overseasInvCheck 按钮是否展示true
            // overseasInvOnlyTiktokCheck true只tk展示,false全部展示
            // shopOverseasInvCheck 白名单权限， true直接展示
            const {
                overseasInvCheck,
                overseasInvOnlyTiktokCheck,
                shopOverseasInvCheck
            } = overseasInv ?? {};
            if (shopOverseasInvCheck) return true;
            if (!overseasInvCheck) return false;
            if (overseasInvOnlyTiktokCheck) {
                return isTikTokShop;
            }
            return false;
        };
        if (isShowStockJpBtn()) {
            showAuth.push(STOCK_JP_SHIPPING);
        }
        if (isCrossMall) {
            showAuth.push(JP_CROSS_MALL_WHITE);
        }
        newList = filterTouter(menuList, showAuth, hiddenAuth);
        return newList;
        return [
            {
                label: window._$m.t('我的工作台'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        src="https://static-s.theckb.com/BusinessMarket/OEM/my_workspace.png"
                        style={{ margin: 10 }}
                    />
                ),

                menulink: '/user/UserCenter'
            },
            {
                label: window._$m.t('订单管理'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/order_manage.png"
                    />
                ),

                children: [
                    (() => {
                        if (stationCode !== Site.KR && isD2C) {
                            return {
                                label: window._$m.t('API同步订单'),

                                menulink: '/order/SyncOrder'
                            };
                        }
                        return undefined;
                    })(),
                    {
                        label: window._$m.t('我的订单'),
                        menulink: '/order/OrderList'
                    },
                    {
                        label: (
                            <div className="absolute contents">
                                {window._$m.t('异常订单')}
                                <Badge
                                    className="absolute"
                                    count={abnormalOrderCount}
                                />
                            </div>
                        ),

                        menulink: '/order/AbnormalOrder'
                    }
                ].filter((item) => item)
            },
            {
                // label: getMenuTitle(
                //     'https://static-s.theckb.com/BusinessMarket/OEM/goods_manage.png',
                //     window._$m.t('商品管理')
                // ),
                label: window._$m.t('商品管理'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/goods_manage.png"
                    />
                ),

                // type: 'group',
                children: [
                    {
                        label: window._$m.t('库存管理'),
                        menulink: '/product/stock'
                    },
                    {
                        label: window._$m.t('品牌授权'),
                        menulink: '/product/brandmanage'
                    },
                    {
                        label: window._$m.t('我的商品测量结果'),
                        menulink: '/product/measure'
                    },
                    stationCode === Site.JP
                        ? {
                              label: window._$m.t('组合商品管理'),
                              menulink: '/product/CombinedGoods'
                          }
                        : undefined,
                    stationCode !== Site.KR &&
                    !(stationCode === Site.UK && !isD2C)
                        ? {
                              label: isD2C
                                  ? window._$m.t('关联商品库')
                                  : window._$m.t('同步商品'),
                              menulink: isD2C
                                  ? '/product/AssociatedProductlib'
                                  : '/product/SyncProduct'
                          }
                        : undefined,
                    {
                        label: window._$m.t('我的收藏'),
                        menulink: '/product/CollectProduct'
                    },
                    {
                        label: window._$m.t('购买过'),
                        menulink: '/product/AfterPurchase'
                    },
                    {
                        label: window._$m.t('足迹'),
                        menulink: '/product/FootPrint'
                    }
                ].filter((i) => i)
            },
            !isD2C
                ? {
                      //   label: getMenuTitle(
                      //       'https://static-s.theckb.com/BusinessMarket/OEM/inShipping.png',
                      //       window._$m.t('国际配送管理')
                      //   ),
                      label: window._$m.t('国际配送管理'),
                      icon: (
                          <img
                              className="sider-icon"
                              alt=""
                              style={{ margin: 10 }}
                              src="https://static-s.theckb.com/BusinessMarket/OEM/inShipping.png"
                          />
                      ),

                      children: [
                          stationCode === Site.JP
                              ? {
                                    label: window._$m.t('FBA补货计划'),
                                    menulink: '/inshipping/ReplenishmentList'
                                }
                              : undefined,
                          {
                              label: window._$m.t('国际发货管理'),
                              menulink: '/inshipping/ShippingList'
                          },
                          {
                              label: window._$m.t('国家发货售后'),
                              menulink: '/inshipping/AfterSale'
                          }
                      ].filter((item) => item)
                  }
                : undefined,
            {
                // label: getMenuTitle(
                //     'https://static-s.theckb.com/BusinessMarket/OEM/fund_manage.png',
                //     window._$m.t('资金管理')
                // ),
                label: window._$m.t('资金管理'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/fund_manage.png"
                    />
                ),

                children: [
                    {
                        label: window._$m.t('资金明细'),
                        menulink: '/fund/CustomerFund'
                    },
                    {
                        label: (
                            <div
                                className={styles.msg}
                                style={{ marginLeft: '14px' }}
                            >
                                <Tooltip
                                    title={
                                        <span className="CustomTooltipTitle">
                                            {window._$m.t(
                                                '借记授权是当系统账户自动扣除以外的费用发生时，向用户收取额外费用的文件。\n 当用户批准付款请求时，费用将从系统余额中扣除。\n ※注意: 如在发出日期起7天内未能确认付款，将自动扣除有关费用。'
                                            )}
                                        </span>
                                    }
                                >
                                    <span
                                        className="submenu"
                                        style={{ marginLeft: '2px' }}
                                    >
                                        <i className="iconfont icon-wenhao1 text-[12px] pr-[2px] " />
                                    </span>
                                </Tooltip>
                                {window._$m.t('我的账单')}
                            </div>
                        ),

                        menulink: '/fund/BillList?type=1'
                    }
                ]
            },
            {
                // label: getMenuTitle(
                //     'https://static-s.theckb.com/BusinessMarket/OEM/oem_manage.png',
                //     'OEM'
                // ),
                label: 'OEM',
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/oem_manage.png"
                    />
                ),

                children: [
                    {
                        label: window._$m.t('新增寻源任务'),
                        menulink: '/oem/order/addFindSource'
                    },
                    {
                        label: window._$m.t('寻源列表'),
                        menulink: '/oem/order/oemSourceList'
                    },
                    {
                        label: window._$m.t('OEM商品'),
                        menulink: '/oem/goods/list'
                    }
                ]
            },
            {
                // label: getMenuTitle(
                //     'https://static-s.theckb.com/BusinessMarket/OEM/store_manage.png',
                //     window._$m.t('店铺管理')
                // ),
                label: window._$m.t('店铺管理'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/store_manage.png"
                    />
                ),

                // type: 'group',
                children: [
                    {
                        label: window._$m.t('店铺配置'),
                        menulink: '/authorized/setupShop'
                    },
                    {
                        label:
                            stationCode === Site.KR
                                ? window._$m.t('子账号配置')
                                : window._$m.t('API/子账号配置'),
                        menulink: '/authorized/AuthorizedStore'
                    }
                    // {
                    //     label: window._$m.t('附加项管理'),
                    //     menulink: '/authorized/AdditionSet'
                    // }
                ]
            },
            {
                label: window._$m.t('会员相关'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/OEM/vip_manage.png"
                    />
                ),

                children: [
                    {
                        label: window._$m.t('会员办理'),
                        menulink: '/vip/VipLevel'
                    },
                    {
                        label: (
                            <div className={styles.msg}>
                                {window._$m.t('消息')}
                                {!!msg && (
                                    <span className={styles.count + ' layout'}>
                                        {msg}
                                    </span>
                                )}
                            </div>
                        ),

                        menulink: '/vip/Information'
                    },
                    {
                        label: window._$m.t('登录账号管理'),
                        menulink: '/vip/setupUser'
                    }
                ]
            },
            {
                label: window._$m.t('应用工具'),
                icon: (
                    <img
                        className="sider-icon"
                        alt=""
                        style={{ margin: 10 }}
                        src="https://static-s.theckb.com/BusinessMarket/Client/utility/Toolkit.png"
                    />
                ),

                children: [
                    {
                        label: window._$m.t('成本计算器'),
                        menulink: '/oem/utility/Calculator'
                    }
                ]
            }
        ].filter((item) => item);
    }, [
        stationCode,
        abnormalOrderCount,
        isJpPurchase,
        isTikTokShop,
        overseasInv,
        isCrossMall
    ]);
    return {
        list
    };
};
const useMenu = (collapse) => {
    const { list } = useList();
    const menu = useMemo(() => {
        const wrapperKey = () => {
            let key = 0;
            return list.map((item: any, index) => {
                const { label, menulink } = item;
                key = key + 1;
                return {
                    ...item,
                    key: key.toString(),
                    label: <div className="text-[16px]"> {label} </div>,

                    children: Array.isArray(item.children)
                        ? item.children.map((it, idx) => {
                              const { label, menulink } = it;
                              key = key + 1;
                              return {
                                  ...it,
                                  key: key.toString(),
                                  label: (
                                      <div
                                          className={
                                              collapse ? '' : 'pl-[26px]'
                                          }
                                      >
                                          {label}
                                      </div>
                                  )
                              };
                          })
                        : undefined
                };
            });
        };
        return wrapperKey();
    }, [collapse, list]);
    return menu;
};
const getMenuItem = (arr, fn) => {
    let item: any = null;
    const _deep = (array) => {
        if (item) return;
        for (let index = 0; index < array.length; index++) {
            const element = array[index];
            if (fn(element)) {
                item = element;
                return;
            }
            if (element?.children?.length) {
                _deep(element?.children);
            }
        }
    };
    _deep(arr);
    return item;
};
const MenuList = () => {
    const [useInfo] = useAtom(CustomerDetail);
    const { stationCode } = useInfo || {};
    const [openKeys, setOpenKeys] = useState<string[]>();
    const [collapse, setCollapse] = useState(false);
    const locationHref = window.location.href;
    const [selectedKeys, setSelectedKeys] = useState<string[]>();
    const menus = useMenu(collapse);

    useLayoutEffect(() => {
        if (!stationCode) return;
        const openSelected = menus.find(
            (a) => a?.children?.some((b) => locationHref.includes(b.menulink))
        );
        if (openSelected?.key) {
            /** 菜单展开 */
            setOpenKeys([openSelected.key]);
            const selectedMenu = openSelected.children.find((a) =>
                locationHref.includes(a.menulink)
            );
            /** 选中菜单 */
            if (selectedMenu) {
                setSelectedKeys(selectedMenu.key);
            }
        }
    }, [menus, stationCode, locationHref]);
    return (
        <div
            className={'menu-slider flex-shrink-0 ' + useInfo?.site}
            style={{
                width: `${collapse ? 'auto' : '240px'}`,
                height: 'calc(100vh - 32px)'
            }}
        >
            <Menu
                inlineCollapsed={collapse}
                selectedKeys={selectedKeys}
                openKeys={openKeys}
                style={{
                    height: 'calc(100vh - 32px)',
                    paddingBottom: 50,
                    borderRight: 0,
                    overflowY: 'scroll'
                }}
                onOpenChange={(_openKeys) => {
                    console.log('openKeys', _openKeys);
                    setOpenKeys(_openKeys);
                }}
                onSelect={({ selectedKeys }) => {
                    const selectedItem = getMenuItem(
                        menus,
                        (item) => item.key === selectedKeys[0]
                    );
                    if (selectedItem?.menulink) {
                        // const _menulink = selectedItem?.menulink.replace('/oem', '');
                        // navigate(_menulink);
                        jumpPage(selectedItem.menulink as any);
                    }
                    setSelectedKeys(selectedKeys);
                }}
                mode="inline"
                className="text-left p-0"
                items={menus as any}
            />

            <div
                className="collapse-btn"
                style={{
                    width: `${collapse ? 62 : 222}px`
                }}
            >
                <img
                    alt=""
                    onClick={() => setCollapse(!collapse)}
                    src={
                        collapse
                            ? 'https://static-s.theckb.com/BusinessMarket/Client/Menu-unfold.svg'
                            : 'https://static-s.theckb.com/BusinessMarket/Client/Menu-fold.svg'
                    }
                />
            </div>
        </div>
    );
};
export default MenuList;
